@import (reference) '../../../../../constants/spacing.module.less';

.top-row {
  justify-content: space-between;
  align-items: flex-start;
}

.description-column {
  flex: 1;
  min-width: 0;
}

.no-description {
  color: var(--grey-600);
}

.bottom-row {
  flex-wrap: wrap;
  align-items: flex-start;
}

.steps-column {
  flex: 1 1 300px;
  min-width: 0;
}

.meta-column {
  flex: 0 0 auto;
  align-items: center;
}

.steps-list {
  display: flex;
  flex-direction: column;
}

.step-item {
  display: flex;
  flex-direction: column;
}

.step-connector {
  display: flex;
  justify-content: center;
  padding: 6px 0;
  color: var(--grey-600);
  font-size: 15px;
}

.summary-step {
  align-items: center;
  padding: @space-8 @space-12;
  background: var(--grey-50);
  border: 1px solid var(--grey-200);
  border-radius: 6px;
}

.step-icon-badge {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--grey-400);
}

.step-icon {
  color: var(--white);
}

.step-icon-trigger {
  background: var(--blue-600);
}

.step-icon-action {
  background: var(--green-600);
}

.step-icon-unconfigured {
  background: var(--grey-400);
}
